var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Add new client",
            description: "Fill in the datas to create a new client.",
            label: "Add new client",
            disabled: _vm.isDisabledSubmit,
            submitLoading: _vm.submitLoading
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onCreate
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "overflow-y-auto lg:w-160",
              style: { maxHeight: "calc(100vh - 16rem)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "bl-backdrop-form-container px-4 lg:px-8 pb-8 flex flex-col gap-4"
                },
                [
                  _c("BlInputText", {
                    attrs: { input: _vm.nameInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-full flex items-center gap-6" },
                    [
                      _c("BlInputDate", {
                        attrs: { input: _vm.birthdayInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        attrs: { input: _vm.emailInput },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.noteInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _vm.enableBranch
                    ? _c("BlSearchBox", {
                        attrs: {
                          type: "branch",
                          label: "Branch tags",
                          placeholder: "Type tag",
                          options: _vm.branchOptions
                        },
                        on: {
                          change: function($event) {
                            _vm.branchIds = $event
                          }
                        },
                        model: {
                          value: _vm.branchIds,
                          callback: function($$v) {
                            _vm.branchIds = $$v
                          },
                          expression: "branchIds"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlSearchBox", {
                    attrs: {
                      type: "tag",
                      label: "Client tags",
                      placeholder: "Type tags",
                      options: _vm.labels.map(function(i) {
                        return { value: i.id, label: i.name }
                      }),
                      drop: "up"
                    },
                    on: {
                      change: function($event) {
                        _vm.labelIds = $event
                      }
                    },
                    model: {
                      value: _vm.labelIds,
                      callback: function($$v) {
                        _vm.labelIds = $$v
                      },
                      expression: "labelIds"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "BlSearchBox",
                    {
                      attrs: {
                        type: "user",
                        label: "Assign to",
                        placeholder: "Type therapist's name",
                        options: _vm.users.map(function(i) {
                          return { value: i.id, label: i.name }
                        }),
                        drop: "up",
                        footer: ""
                      },
                      on: {
                        change: function($event) {
                          _vm.userIds = $event
                        }
                      },
                      model: {
                        value: _vm.userIds,
                        callback: function($$v) {
                          _vm.userIds = $$v
                        },
                        expression: "userIds"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex gap-2 p-2 bg-cornflower-200 rounded-b"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-4 -mt-0.5",
                            attrs: { icon: "info", color: "cornflower-8" }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-cornflower-800 flex-wrap",
                            attrs: {
                              text:
                                "Only administrators and designated therapists will have access to view the client."
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.accessNoticeOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Access notice: limited client view",
              description:
                "Your account is restricted to viewing only clients assigned to you. Since you've opted out of being assigned to this client, you won't be able to access their information after creating their profile. To retain access, please assign yourself in the 'Assign to' input field before finalizing.",
              label: "Confirm and create"
            },
            on: {
              "backdrop-close": function($event) {
                _vm.accessNoticeOpened = false
              },
              "backdrop-action": _vm.onCompleteCreating
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af1bdac2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af1bdac2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/client/NewClientModal.vue
// module id = null
// module chunks = 